window.addEventListener("DOMContentLoaded",()=>{
// Select the target node (the element you want to observe)
const cartNotification = document.getElementById('cart-notification');

// Options for the observer (which mutations to observe)
const config = {
  attributes: true, // Observe attribute changes
  attributeFilter: ['class'] // Only observe changes to the 'class' attribute
};

// Callback function to execute when mutations are observed
const callbackCartNotification = async(mutationsList, observer)=> {
  for (let mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const element = mutation.target;
      if (element.classList.contains('active')) {
        //console.log('Class "yourClassName" has been added to the element.');

        var cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { return data });
  const cartSubtotalPrice = (cartContents.items_subtotal_price/100).toFixed(2);
  const cartNotificationSubtotal = document.querySelector(".cart-notification-subtotal");
  const youSaveDOM = document.querySelector(".savings_text");
  cartNotificationSubtotal.textContent=`$${cartSubtotalPrice}`;
const cartItems=cartContents.items;
let memberShipPrice = 0;
    let  quarterly_membership = "Few Moda Quarterly Membership";
  let yearly_membership = "Few Moda Yearly Membership";
let retailPrice =0;
//console.log("cartItems",cartItems)
/*
cartItems.forEach(item => {
    console.log("item",item)
    console.log("item variant",item.variant)

    let tmpPrice = item.quantity * item.variant.compare_at_price
retailPrice +=tmpPrice; 

if(item.title == quarterly_membership || item.title == yearly_membership || item.id ==39657980068101)
memberShipPrice=item.price;
    
});
let YouSavedPrice =((retailPrice - cartContents.original_total_price)/100).toFixed(2) ; 

youSaveDOM.textContent = `By being a member you are saving $${YouSavedPrice} on this order alone.`

*/

      } 

    }
  }
};

// Create an observer instance linked to the callback function
const observerCartNotification = new MutationObserver(callbackCartNotification);

// Start observing the target node for configured mutations
if(cartNotification)
observerCartNotification.observe(cartNotification, config);







})